import useHubs from '@/hooks/use-hubs';

export const PAGE_ROUTES = {
  DEALS: 'deals',
  BOARD: 'board',
  DEAL: 'deal',
  INBOX: 'inbox',
  MY_DEALS: 'my-deals',
  MY_DEALS_BOARD: 'my-deals-board',
  ARCHIVED_DEALS: 'archived-deals',
  MY_TASKS: 'my-tasks',
  TASKS: 'tasks',
  CONTRACT_QUEUE: 'contract-queue',
  STAGES: 'stages',
  DELIVERY_QUEUE: 'delivery-queue',
  LOG_BOOK: 'logbook',
  HOTKEYS: 'hotkeys',
  ABOUT: 'about',
  CONNECTED_ACCOUNTS: 'connections',
  AUTH: 'auth',
  PROFILE: 'profile',
  TRADES: 'trades',
  TRADE_IN: 'trade',
  CARS: 'cars/all',
  APPRAISALS: 'appraisals',
  FLEET: 'fleet',
  LEADS: 'leads',
};

export const useBuildHubSlashInboxUrl = () => {
  const { hubPathIdentifier } = useHubs();
  return `/${hubPathIdentifier}/${PAGE_ROUTES.INBOX}`;
};

export const useBuildHubSlashDealsUrl = () => {
  const { hubPathIdentifier } = useHubs();
  return `/${hubPathIdentifier}/${PAGE_ROUTES.DEALS}`;
};

export const useBuildHubSlashContractQueueUrl = () => {
  const { hubPathIdentifier } = useHubs();
  return `/${hubPathIdentifier}/${PAGE_ROUTES.CONTRACT_QUEUE}`;
};

export const getTradePathname = (tradeShortId: string) => {
  return `/${PAGE_ROUTES.TRADE_IN}/${tradeShortId}`;
};

export const getAppraisalPathname = (appraisalId: string) => {
  return `/${PAGE_ROUTES.APPRAISALS}/${appraisalId}`;
};

export const getDealPathname = (dealShortId: string, hub: string) => {
  return `/${hub}/${PAGE_ROUTES.DEAL}/${dealShortId}`;
};
